import React, { useEffect, useState } from "react";
import MspUserManagement from "./MspUserManagement";
import OrgUserManagement from "./OrgUserManagement";
import OnPremUserManagement from "./OnPremUserManagement";

const UserManagement = () => {
  const runningContext = process.env.REACT_APP_RUNNING_CONTEXT;
  const [isMspView, setIsMspView] = useState(null);
  const breadcrumbs = JSON.parse(localStorage.getItem("selectBreadcrumbs"));
  const hasManageOrg = breadcrumbs.realm?.hasManageOrg === true;
  const realmId = breadcrumbs.realm?.id ?? null;
  const orgsId = breadcrumbs.orgs?.id ?? null;

  let entId = null;
  let orgId = null;

  if (hasManageOrg) {
    entId = realmId;
    if (orgsId) {
      orgId = orgsId;
    }
  } else {
    orgId = realmId;
  }

  useEffect(() => {
    const stored = localStorage.getItem("selectBreadcrumbs");
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        const realm = parsed?.realm;
        const hasRealm = realm && Object.keys(realm).length > 0;
        const hasManageOrg = realm?.hasManageOrg === true;
        const hasNoOrgs =
          !parsed?.orgs || Object.keys(parsed.orgs).length === 0;
        const hasNoSite =
          !parsed?.site || Object.keys(parsed.site).length === 0;

        const showMspView = hasRealm && hasManageOrg && hasNoOrgs && hasNoSite;
        setIsMspView(showMspView);
      } catch (err) {
        console.error("Invalid JSON in selectBreadcrumbs:", err);
        setIsMspView(false);
      }
    } else {
      setIsMspView(false);
    }
  }, []);

  if (isMspView === null) return null;

  if (runningContext === "premises") {
    return <OnPremUserManagement orgId={orgId} />;
  }

  return isMspView ? (
    <MspUserManagement entId={entId} />
  ) : (
    <OrgUserManagement entId={entId} orgId={orgId} />
  );
};

export default UserManagement;
